// Single source of truth for the palette. CSS custom properties live in index.css;
// these JS mirrors are for places that need a literal value (SVG fills, canvas, etc).
export const HEX = {
  side: '#0f3125',
  side2: '#0b2419',
  sideHi: '#123a2b',
  mint: '#3ecf8e',
  mint2: '#7fe3bf',
  tealink: '#78a795',
  tealdim: '#4d7666',
  gold: '#f2c21a',
  gold2: '#e0a800',
  cream: '#f4f2ea',
  card: '#ffffff',
  card2: '#faf9f4',
  ink: '#15211b',
  ink2: '#54635a',
  muted: '#8b978f',
  border: '#e6e3d8',
  grid: '#eae7dc',
  axis: '#d5d1c4',
  s1: '#2a78d6',
  s2: '#eb6834',
  s3: '#1baf7a',
  s4: '#eda100',
  s5: '#e87ba4',
  good: '#0ca30c',
  goodInk: '#0a7d18',
  warn: '#c98a00',
  crit: '#d03b3b',
};

// Series palette, in order — channel N takes slot N.
export const SERIES_HEX = [HEX.s1, HEX.s2, HEX.s3, HEX.s4, HEX.s5];

export const FONT_DISPLAY = '"Outfit", system-ui, -apple-system, "Segoe UI", sans-serif';
export const FONT_SANS = FONT_DISPLAY;
export const FONT_MONO = '"JetBrains Mono", ui-monospace, "SF Mono", Menlo, monospace';

export const SHADOW = '0 1px 2px rgba(20,40,30,.05),0 8px 24px rgba(20,40,30,.06)';
export const RADIUS = 14;
